import React from 'react'
import { Redirect, } from 'react-router-dom'
import useReactRouter from 'use-react-router'
import { getRedirectQueryParamFromLocation, } from '@shapr/react-shared/utils/queryParam'
import appendQuery from 'append-query'

import localStorageConfig from '~/config/localStorageConfig'
import redirectConfig from '~/config/redirect'

const withLoggedUser = Component => props => {
  const authToken = localStorage.getItem(localStorageConfig.authToken)
  const { location, } = useReactRouter()

  if (authToken) {
    return <Component {...props} />
  } else {
    return (
      <Redirect
        to={appendQuery(
          '/login',
          getRedirectQueryParamFromLocation({
            location,
            defaultRedirect: redirectConfig.default,
          }),
        )}
      />
    )
  }
}

export default withLoggedUser
